﻿import { Stepper } from "../../components/stepper";
import { getDropdownValue, setDropdownValue } from "../../components/dropdown";
import { setCookie, deleteCookie, getCookie } from "../../storage";
import { focusOnSearch, getPreferences } from "./step4";
import { EuiModalSize, showModal } from "../../components/modal";
import { initLoader } from "./loader";

const MAX_SAVED_REGISTER_STEP = 3;

let registerStepper;

// Prevents browsers to load form values from cache.
$(window).bind("pageshow", (event) => {
  if (event.originalEvent.persisted) {
    window.location.reload();
  }
});

$(() => {
  registerStepper = new Stepper($("#registerStepper"));
  const params = new URLSearchParams(window.location.search);

  if (params.get("fill")) {
    fillRegisterForm();
  }
});

window.nextStep = () => {
  const registerValues = getRegisterValues();
  const currentIndex = registerValues.index ? registerValues.index : 0;

  if (currentIndex < registerStepper.index + 1) {
    registerValues["index"] =
      registerStepper.index >= MAX_SAVED_REGISTER_STEP
        ? MAX_SAVED_REGISTER_STEP
        : registerStepper.index + 1;
    setCookie(REGISTER_COOKIE_NAME, JSON.stringify(registerValues), "/");
  }

  if(currentIndex == 3) focusOnSearch();
  registerStepper.next();
};

window.prevStep = () => {
  registerStepper.prev();
};

export function initRegisterForm(form) {
  const formSettings = $.data($(form)[0], "validator").settings;

  formSettings.submitHandler = (form) => {
    $("input:not(.not-track)", form).blur();

    if (registerStepper.index === 4) {
      completeRegister();
    } else {
      $(":input[id][name]:not(.not-track)", form)
        .toArray()
        .forEach((input) => {
          setRegisterValue(input);
        });
      nextStep();
    }
  };
}

export function getRegisterValues() {
  let registerValues;

  try {
    registerValues = JSON.parse(getCookie(REGISTER_COOKIE_NAME));
  } catch (error) {
    registerValues = {};
  }

  return registerValues;
}

export function setRegisterValue(input) {
  if (!input.hasAttribute("id")) {
    return;
  }

  input = $(input);

  const registerValues = getRegisterValues();
  const name = input.attr("id");

  if (!registerValues.country) {
    registerValues["country"] = CURRENT_COUNTRY_CODE;
  }

  if (RETURN_OFFER && RETURN_OFFER.trim().length > 0) {
    registerValues["returnOffer"] = RETURN_OFFER;
  }

  let value;

  const isInputDropdown = input.closest(".eui-dropdown").length > 0;
  if (isInputDropdown) {
    value = {
      text: input.val(),
      value: input.attr("eui-dropdown-val"),
    };
  } else if (input.attr("type") == "checkbox") {
    value = input.is(":checked");
  } else {
    value = input.val();
  }

  if (!registerValues.values) {
    registerValues["values"] = {};
  }

  registerValues.values[name] = value;
  setCookie(REGISTER_COOKIE_NAME, JSON.stringify(registerValues), "/");
}

function fillRegisterForm() {
  const registerValues = getRegisterValues();

  if (registerValues.country !== CURRENT_COUNTRY_CODE) {
    return;
  }

  if (registerValues.index) {
    registerStepper.changeStep(registerValues.index);
  }

  if (!registerValues.values) {
    return;
  }

  for (const [key, value] of Object.entries(registerValues.values)) {
    const input = $("#" + key);

    const isInputDropdown = input.hasClass("eui-dropdown-wrapper");
    if (isInputDropdown) {
      setDropdownValue(input, value.text, value.value);

      $(".eui-input", input).trigger("change");
      $(".eui-input-content", input).addClass("eui-input-content--filled");
    } else if (input.attr("type") == "checkbox") {
      input.prop("checked", value);
    } else {
      input.val(value);
    }

    input.trigger("change");
  }
}

function completeRegister() {
  $("#register").hide();
  $("#registerLoading").removeClass("eui-d-none");
  initLoader();
  const button = $("#completeRegisterBtn");
  const registerValues = {};

  button.attr("disabled", true);

  $("#registerStepper form").each((_, form) => {
    const formInputs = $(form).serializeArray();
    formInputs.forEach((input) => {
      if (!registerValues.hasOwnProperty(input.name)) {
        let value = input.value;

        const inputEl = $(`#${input.name}`);
        if (
          inputEl.length > 0 &&
          $(`#${input.name}`).hasClass("eui-dropdown-wrapper")
        ) {
          value = getDropdownValue(inputEl).value;
        }

        registerValues[input.name] = value;
      }
    });
  });

  const _tmpRegisterValues = JSON.parse(getCookie(REGISTER_COOKIE_NAME));
  registerValues["Country"] = _tmpRegisterValues.country;
  registerValues["Radius"] = parseInt(_tmpRegisterValues.values.Radius);
  registerValues["Latitude"] =
    _tmpRegisterValues.values.Latitude.toString().replace(".", ",");
  registerValues["Longitude"] =
    _tmpRegisterValues.values.Longitude.toString().replace(".", ",");
  registerValues["PostalCode"] =
    _tmpRegisterValues.values.PostalCode.split(", ")[0];

  // Data quality
  registerValues["Name"] = registerValues["Name"].trim();
  registerValues["Surname"] = registerValues["Surname"].trim();
  registerValues["SecondSurname"] = registerValues["SecondSurname"].trim();

  registerValues["Preferences"] = getPreferences();
  if (registerValues["Preferences"].length === 0)
    registerValues["NeedSetAlerts"] = "false";
  registerValues["ReturnOffer"] = getRegisterValues()["returnOffer"]
    ? decodeURIComponent(getRegisterValues()["returnOffer"])
    : "";

  $.post(CREATE_USER_URL, registerValues)
    .done((completedView) => {
      deleteCookie(REGISTER_COOKIE_NAME, "/");
      $("#registerLoading").addClass("eui-d-none");
      $("#registerCompleted").html(completedView);

      const isSubscribed = registerValues["IsSubscribed"] === "true";
      if (window.dataLayer)
        isSubscribed
          ? window.dataLayer.push({ event: "AceptarComunicacionesRegistro" })
          : window.dataLayer.push({ event: "NoAceptarComunicacionesRegistro" });

      const needSetAlerts = registerValues["NeedSetAlerts"] === "true";
      if (window.dataLayer && needSetAlerts)
        window.dataLayer.push({ event: "Registre_switch_alertes" });

      if (window.pushUTM)
        window.pushUTM(
          `${FRONT_OFFICE_URL}UTMs/InsertUserRegisterUTMEvent?workerId=${WORKER_ID}`
        );
      if (window.addBrazeEvent) window.addBrazeEvent("B2C - Sign up");
      if (window.changeUser) window.changeUser(WORKER_GUID.toUpperCase());
    })
    .fail((errorRequest) => {
      console.error("error create user");

      switch (errorRequest.status) {
        case 409:
          showModal($("#errorDniModal"), {
            overlayClose: false,
            size: EuiModalSize.S,
          });

          window.dataLayer.push({
            event: "error_finalizar_registro",
            mycategory: ["authweb"],
            myaction: ["register"],
            mylabel: ["error_finalizar_registro"],
          });

          break;
      }

      button.removeAttr("disabled");
    })
    .always(() => {
      button.removeAttr("disabled");
    });
}
